"use client";
import CommonImage from "@/components/common/image/CommonImage";
import HomePageService from "@/services/api/HomeService";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import Link from "next/link";
import SkeletonProgramSection from "@/components/common/skeletons/SkeletonProgramSection";
export default function ProgramSection({ programs, loading }) {
  const setting = useSelector((state) => state.setting.data);
  // console.log("Settings", setting);
  return (
    <>
      {/* {loading ? (
        <SkeletonProgramSection />
      ) : ( */}
        <section className="program_section bg-pattern">
          {loading && (
            <motion.div
              className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-80 z-50"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <motion.div
                className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"
                animate={{ rotate: 360 }}
                transition={{
                  repeat: Infinity,
                  duration: 1,
                  ease: "linear",
                }}
              />
            </motion.div>
          )}
          <div className="container">
            <div className="program-section-card animated-border">
              <div className="section_title section_title-white">
                {setting && 
                <h2 className="title">
                  <span className="w-8 h-8">
                    <CommonImage
                      src={"/images/home-page/book-icon.avif"}
                      className="img-icon"
                      alt="Book Icon"
                    />{" "}
                  </span>{" "}
                  {setting?.program_title}
                </h2>
              }

                <p className="short-des">{setting?.program_sub_title}</p>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-3 sm:grid-cols-2 gap-6 section-content-wrap">
                {programs?.map((program) => (
                  <Link key={program.slug} href={`courses/${program.slug}`}>
                    <div className="program-item">
                      <div className="item-card">
                        <div className="program-icon">
                          <CommonImage
                            src={program.icon_url}
                            className="img-icon"
                            alt="Program Icon"
                          />
                        </div>
                        <div className="item-content">
                          <h4 className="title">{program.name}</h4>
                          <p className="short-des">{program.subtitle}</p>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>
      {/* )} */}
    </>
  );
}
